<template>
    <div class="container" v-bind:style="containerStyle">
        <div class="d-inline-block">
            <img
                    v-if="hasImage"
                    v-bind:style="style"
                    v-bind:src="imageUrl"
                    v-bind:alt="metadata.tooltip"
            >
            <i v-else class="fa fa-file-image fa-5x" v-bind:style="placeholderStyle"></i>
        </div>
    </div>
</template>

<script>
    import generateRuleset from '../../CustomStylingOptions/ruleset-generator';

    import imageUrlMixin from '../../Mixins/image-url';
    
    // import {generateStyle as generatePositionStyle} from "../../CustomStylingOptions/positions";

    export default {
        name: "template-column-image",
        mixins: [imageUrlMixin],
        computed: {
            placeholderStyle(){
                const vm = this;
                
                const ruleset = generateRuleset();
                
                ruleset.setRule('display', 'block');
                ruleset.setRule('position', 'relative');
                ruleset.setRule('width', '50px');
                
                ruleset.setContentPosition(vm.metadata.style.size, vm.metadata.style.position);

                return ruleset.toString();
            },
            containerStyle(){
                const vm = this;
                
                const ruleset = generateRuleset();
                ruleset.setPositionContainerRules(vm.metadata.style.position);
                return ruleset.toString();
            },
            style(){
                const vm = this;
                const maxHeight = 100;
                const maxWidth = 100;

                //Forcing a 1:1 aspect ratio should make rotation a bit easier
                //TODO: Don't force 1:1 aspect ratio?
                const ruleset = generateRuleset();

                ruleset.setRule('display', 'block');
                ruleset.setRule('position', 'relative');

                ruleset.setFloatBasedContentPosition(vm.metadata.style.size, vm.metadata.style.position);

                ruleset.setRule('height', `${(vm.metadata.style.size / 100) * maxHeight}%`);
                ruleset.setRule('width', `${(vm.metadata.style.size / 100) * maxWidth}%`);
                
                return ruleset.toString();
            },
            imageUrl(){
                const vm = this;
                
                if(!vm.hasImage){
                    return null;
                }
                
                return vm.getImageUrl(vm.metadata.mediaId, vm.metadata);
            },
            hasImage(){
                const vm = this;
                
                return !!vm.metadata.mediaId;
            }
        },
        props: {
            metadata: {
                type: Object,
                required: true
            }
        }
    };
</script>

<style scoped>
    .container{
        display: block;
    }
</style>
